<template>
  <!-- <ProgressDialog :loading="dashboardState.isLoading" loadingText="Loading animation..." /> -->
  <div v-if="dashboardState.dashboard" ref="rootElement" class="layers-container">
    <DashboardLayer ref="dashboardLayer" v-for="layer in dashboardState.dashboard.layers"
      :key="`${layer.id}-${uniqueKey}`" :layer="layer" :isPreview="isPreview" :isMobileDevice="isMobileDevice"
      @backgroundImageLoaded="handleBackgroundImageLoaded" />
    <DashboardData ref="dashboardData" v-for="(data, index) in this.dashboardState.dashboard.data"
      :style="isMobileDevice ? { left: `${windowCenter}px` } : {}" :key="`dashboard-data-${uniqueKeyData}-${index}`"
      :data="data" :isPreview="isPreview" :isEditor="isEditor" :isPortraitMode="isPortraitMode"
      :isMobileDevice="isMobileDevice" :conf="['pos0', 'pos1', 'pos2', 'pos3', 'pos4'][index % dataCount]"
      :idx="index"
      @animationComplete="handleAnimationComplete(index)" />

    <div class="impressum-bar">
      <p class="impressum-text">
        <a :href=impressumUrl target="_blank">Impressum</a> | 
        <a :href=privacyUrl target="_blank">Datenschutz</a> | 
        <a :href=aboutUsUrl target="_blank">{{aboutUsText}}</a>
      </p>
    </div>
  </div>

  <div class="dashboard-ui" v-if="!isPreview && !isMobileDevice">
    <DButton class="hover-visibility" @click="toggleFullscreen" color="primary" label="Toggle Fullscreen" />
    <DButton class="hover-visibility" v-if="isHomeButtonVisible" @click="goHome" icon="home" color="primary" style="margin-left: 16px;"
      tooltip="Home" />
  </div>
  

  <h1 v-if="!dashboardState.dashboard">No active dashboard</h1>
</template>

<script>
import DashboardLayer from "@components/DashboardLayer.vue"
import DashboardData from "@components/DashboardData.vue"
// import ProgressDialog from '@components/ui/ProgressDialog.vue'
import DButton from '@components/ui/DButton.vue'
import { gsap } from 'gsap'
import getEnv from '@/utils/env'

export default {
  inject: ['dashboardState'],
  components: {
    /*ProgressDialog,*/ 
    DButton, 
    DashboardLayer,
    DashboardData
  },
  props: {
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isEditor: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileDevice: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      // currentDashboardIndex: 0,
      rootElement: null,
      isPortraitMode: false,
      uniqueKey: 0,
      uniqueKeyData: 0,
      windowCenter: 0,
      hasScrolled: false,
      // firstTriplet: true,
      // lastTriplet: false,
      impressumUrl: getEnv('VUE_APP_IMPRESSUM_URL'),
      aboutUsUrl: getEnv('VUE_APP_ABOUT_US_URL'),
      aboutUsText: getEnv('VUE_APP_ABOUT_US_TEXT'),
      privacyUrl: getEnv('VUE_APP_PRIVACY_URL'),
      dataCount: parseInt(getEnv('VUE_APP_DATA_COUNT')) || 3,
      animationSpeed: parseFloat(getEnv('VUE_APP_ANIMATION_SPEED')) || 1,
      showTime: parseInt(getEnv('VUE_APP_SHOW_TIME')) * 1000 || 20000
    }
  },
  computed: {
    isHomeButtonVisible() {
      return this.$router.currentRoute.value.path.includes('admin')
    },
    // visibleDashboardData() {
    //   // Return the current slice of data based on currentDashboardIndex
    //   if (Array.isArray(this.dashboardState.dashboard.data)) {
    //     return this.dashboardState.dashboard.data.slice(0, this.currentDashboardIndex + 1)
    //   } else {
    //     console.error('this.dashboardState.dashboard.data is not an array')
    //     return []
    //   }
    // }
  },

  methods: {
    handleBackgroundImageLoaded(imgWidth) {
      imgWidth
      // if (this.isMobileDevice && window.screen.orientation.type.includes('portrait')) {

      //   if (!this.hasScrolled) {
      //     try {
      //       this.windowCenter = imgWidth / 2 - this.$refs.dashboardData[0].$refs.animationContainer.offsetWidth / 2
      //     } catch (error) {
      //       this.windowCenter = imgWidth / 2 // in case there are not bubbles, just center the first element
      //     }
      //     const container = this.$refs.rootElement
      //     if (container) {
      //       this.hasScrolled = true
      //       document.getElementById('pivotDiv').scrollIntoView()
      //       //this.$refs.dashboardLayer.scrollToPivotDiv()
      //     }
      //   }
      // }
    },
    checkOrientation() {
      if (window.screen.orientation.type.includes('portrait')) {
        this.isPortraitMode = true
      } else {
        this.isPortraitMode = false
        this.windowCenter = 0
      }
    },

    goHome() {
      this.$router.push('/admin')
    },
    toggleFullscreen() {
      let elem = this.rootElement
      elem.style.backgroundColor = "white"
      if (!document.fullscreenElement) {
        elem.classList.add("fullscreen-mode")
        document.body.classList.add("fullscreen-active")
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
      } else {
        elem.classList.remove("fullscreen-mode")
        document.body.classList.remove("fullscreen-active")
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    hideBubble(index) {
      //console.log("hideBubble " + index);
      gsap.timeline().to(this.$refs.dashboardData[index].$refs.animationContainer, {
        autoAlpha: 0, 
        duration: this.animationSpeed * 10,
        onComplete: () => {
          if (index >= this.$refs.dashboardData.length - 1) {
            //console.log("Was Last, so reset Dashboard");
            this.resetDashboard()
          }
        }
      })
    },
    handleAnimationComplete(index) {
      //console.log("handleAnimationComplete " + index);
      let hideAfter = this.showTime + (this.dataCount - 1) * 10000
      //console.log("hideAfter " + hideAfter)
      setTimeout(() => {
           this.hideBubble(index)
      }, (this.animationSpeed * hideAfter))

    },
    resetDashboard() {
      //console.log("Reset dashboard")
      // this.currentDashboardIndex = 0
      // this.firstTriplet = true
      // this.lastTriplet = false
      // this.uniqueKeyData = Date.now()
      this.$refs.dashboardData.forEach((dashboardDataComponent) => {
        dashboardDataComponent.reset()
      })
    },
    // incrementDashboardIndex() {
    //   this.currentDashboardIndex++
    //   if (this.currentDashboardIndex >= this.dashboardState.dashboard.data.length) {
    //     // Reset or handle completion here
    //     // console.log("Reset dashboard after timeout")
    //     // setTimeout(() => {
    //       this.resetDashboard()
    //     // }, this.animationSpeed * this.dataCount * 10000)
    //   }
    // }
  },
  mounted() {
    if (this.isMobileDevice && this.isPortraitMode) {
      this.dataCount = 3
    }
    this.rootElement = this.$refs.rootElement
    window.addEventListener('orientationchange', this.checkOrientation)
  },
  beforeUnmount() {
    window.removeEventListener('orientationchange', this.checkOrientation)
  }
}
</script>

<style lang="scss" scoped>
.fullscreen-mode {
  overflow: hidden;
  background-color: white;
}

.fullscreen-mode>.content {
  min-height: 110vh;
}

body.fullscreen-active {
  overflow: hidden;
  background-color: white;
}

.hover-visibility {
  opacity: 0;
}

.hover-visibility:hover{
  opacity: 1;
}

.dashboard-ui {
  position: absolute;
  left: 16px;
  top: 16px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 10px;
}

.layers-container {
  width: 100%;
  height: 100%;
  //aspect-ratio: 16 / 9;
  //overflow: auto;
}

button {
  z-index: 9999;
  position: relative;
}

.suspected-overlaying-element {
  pointer-events: none;
}

.impressum-bar {
    z-index: 9999;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: left;
    padding: 0;
    margin: 0;
}

.impressum-text {
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.1); /* Transparent background */
    color: #fff;
    padding: 0px 10px;
    border-radius: 0px 5px 0px 0px;
    margin: 0;
    color: rgba(200, 200, 200, 0.2);
}

.impressum-bar a {
    color: rgba(200, 200, 200, 0.6);
    text-decoration: none;
    font-size: small;
}

.impressum-bar a:hover {
    text-decoration: underline;
}
</style>
